import { ACCOUNT_DROPDOWN } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case ACCOUNT_DROPDOWN:
            return {...state, ..._.mapKeys(action.payload, 'value')}
        default:
            return state;
    }
}